import React from 'react';

/**
 * Cinematic environment:
 *  - Volumetric light rays (CSS conic/linear)
 *  - Drifting fog layers
 *  - Subtle scan line
 *  - Film grain overlay
 */
const LightRays = () => {
  return (
    <div className="pointer-events-none fixed inset-0 z-[1] overflow-hidden" aria-hidden>
      {/* Radial base halo (camera lens vignette) */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(34,211,238,0.18), transparent 55%),' +
            'radial-gradient(ellipse 60% 40% at 100% 100%, rgba(14,165,233,0.10), transparent 55%),' +
            'radial-gradient(ellipse 50% 40% at 0% 80%, rgba(255,255,255,0.035), transparent 55%)',
        }}
      />

      {/* Volumetric light rays (top) */}
      <div className="absolute inset-x-0 top-0 h-[80vh] animate-rayDrift mask-fade-b" style={{ mixBlendMode: 'screen' }}>
        <div
          className="absolute left-1/2 top-0 w-[140vw] h-full -translate-x-1/2 opacity-70"
          style={{
            background:
              'conic-gradient(from 200deg at 50% -20%, transparent 0deg, rgba(34,211,238,0.22) 12deg, transparent 24deg, transparent 40deg, rgba(165,243,252,0.12) 50deg, transparent 60deg, transparent 100deg, rgba(34,211,238,0.18) 110deg, transparent 125deg, transparent 180deg, rgba(255,255,255,0.05) 190deg, transparent 200deg, transparent 360deg)',
            filter: 'blur(24px)',
          }}
        />
      </div>

      {/* Drifting fog layer */}
      <div className="absolute inset-0 animate-fogDrift opacity-70">
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 60% 40% at 20% 30%, rgba(14,165,233,0.12), transparent 60%),' +
              'radial-gradient(ellipse 50% 30% at 80% 60%, rgba(255,255,255,0.04), transparent 60%)',
            filter: 'blur(40px)',
          }}
        />
      </div>

      {/* Scan line (subtle, cinematic) */}
      <div
        className="absolute inset-x-0 h-[2px] animate-scanLine"
        style={{
          background: 'linear-gradient(90deg, transparent, rgba(34,211,238,0.35), transparent)',
          filter: 'blur(1.5px)',
          mixBlendMode: 'screen',
        }}
      />

      {/* Film grain */}
      <div className="absolute inset-0 grain opacity-[0.05] mix-blend-overlay" />

      {/* Bottom fade for scene separation */}
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black to-transparent" />
    </div>
  );
};

export default LightRays;
